/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Connection_TabInputs */

const en_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection`)
};

const fr_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion`)
};

const de_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung`)
};

const it_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione`)
};

const ru_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связь`)
};

const es_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexión`)
};

const zh_cn2_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系`)
};

const ja_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繋がり`)
};

const hi_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संबंध`)
};

const pt_pt2_live_caption_connection_tab = /** @type {(inputs: Live_Caption_Connection_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexão`)
};

/**
* | output |
* | --- |
* | "Connection" |
*
* @param {Live_Caption_Connection_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_connection_tab = /** @type {((inputs?: Live_Caption_Connection_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Connection_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_connection_tab(inputs)
	if (locale === "de") return de_live_caption_connection_tab(inputs)
	if (locale === "it") return it_live_caption_connection_tab(inputs)
	if (locale === "ru") return ru_live_caption_connection_tab(inputs)
	if (locale === "es") return es_live_caption_connection_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_connection_tab(inputs)
	if (locale === "ja") return ja_live_caption_connection_tab(inputs)
	if (locale === "hi") return hi_live_caption_connection_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_connection_tab(inputs)
	return en_live_caption_connection_tab(inputs)
});